import { http } from '../../../../api/http';
import type { GuiaEntradaCompra } from '../types/guiaEntradaCompra.types';

export class GuiaEntradaCompraService {
  private static readonly BASE = '/compras/guia-entrada';

  public static async getAll(): Promise<GuiaEntradaCompra[]> {
    const response = await http.get(this.BASE);
    return response.data;
  }

  public static async getById(id: number): Promise<GuiaEntradaCompra> {
    const response = await http.get(`${this.BASE}/${id}`);
    return response.data;
  }

  public static async save(data: GuiaEntradaCompra): Promise<GuiaEntradaCompra> {
    const response = await http.post(this.BASE, data);
    return response.data;
  }

  public static async delete(id: number): Promise<boolean> {
    await http.delete(`${this.BASE}/${id}`);
    return true;
  }

  public static async cerrar(id: number): Promise<GuiaEntradaCompra> {
    const response = await http.post(`${this.BASE}/${id}/cerrar`);
    return response.data;
  }
}
